module.exports = __webpack_public_path__ + "img/swap-icon.0593da80.svg";